import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { Users } from '../../core/interfaces/users.interface';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectOptions } from '../../core/interfaces/select-options.interface';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterModule } from "@angular/router";
import { UsersService } from '../../core/services/users/users.service';
import { HttpStatusCode } from 'axios';

@Component({
  selector: 'app-manage-users',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    RouterModule
  ],
  templateUrl: './manage-users.page.html',
  styleUrl: './manage-users.page.scss'
})
export class ManageUsersPage implements OnInit, AfterViewInit {

  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private usersService = inject(UsersService);

  protected readonly userRoles: SelectOptions[] = [
    {
      name: "Super Admin",
      value: "Super Admin"
    },
    {
      name: "Admin",
      value: "Admin"
    }
  ];

  protected readonly userStatus: SelectOptions[] = [
    {
      name: "Active",
      value: "Active"
    },
    {
      name: "Inactive",
      value: "Inactive"
    }
  ];

  protected userListData: Users[] = [];
  protected userListTableDisplayColumn: string[] = ["sno", "name", "email", "contactNo", "userCategory", "isActive", "actions"];
  protected userListTableDataSource = new MatTableDataSource<Users>();

  @ViewChild('userListTablePaginator')
  userListTablePaginator!: MatPaginator;
  @ViewChild('userListTableSort')
  userListTableSort!: MatSort;

  userListFilterFg!: FormGroup;

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.userListFilterFg = this.formBuilder.group({
      searchKeyword: [""],
      userRole: [""],
      userStatus: [""]
    });

    await this.getUserList();
    this.userListTableDataSource.data = this.userListData;
  }

  ngAfterViewInit(): void {
    this.userListTableDataSource.paginator = this.userListTablePaginator;
    this.userListTableDataSource.sort = this.userListTableSort;
  }

  async getUserList() {
    const responseData = await this.usersService
      .getUserList()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    // Handling the response from the API call.
    if (responseData.status === HttpStatusCode.Ok) {
      this.userListData = responseData.data.responsedata;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

      this.sessionStorageService.clearSessionStorage();
    }
  }

  protected __applyUserListFilter() {
    const filterValue = this.userListFilterFg.controls['searchKeyword'].value;
    const userRole = this.userListFilterFg.controls['userRole'].value;
    const userStatus = this.userListFilterFg.controls['userStatus'].value;

    let userIsActive: boolean;
    if (userStatus === 'Active') {
      userIsActive = true;
    }
    if (userStatus === 'Inactive') {
      userIsActive = false;
    }

    let tempUserListTableData: Users[] = [];

    if (filterValue && !userRole && !userStatus) {
      // tempUserListTableData = this.userListData.filter(user => 
      //   user.personName.toLowerCase().includes(filterValue)
      //   || user.email.toLowerCase().includes(filterValue)
      //   || user.contactno.toLowerCase().includes(filterValue)
      //   || user.userCategory.toLowerCase().includes(userRole)
      //   || (userIsActive && userIsActive ? user.isActive : !user.isActive )
      // );
      tempUserListTableData = this.userListData.filter(user =>
        user.personName.toLowerCase().includes(filterValue)
        || user.email.toLowerCase().includes(filterValue)
        || user.contactno.toLowerCase().includes(filterValue)
      );
    } else {
      tempUserListTableData = this.userListData;
    }

    this.userListTableDataSource.data = tempUserListTableData;
  }

}
